import Vue from 'vue'
import App from './App.vue'
import './assets/tailwind.css'  // 👈 必须写在这里
import './assets/css/common.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,  // 这样才叫使用了
  render: h => h(App)
}).$mount('#app')